import "phoenix_html";
import { Socket } from "phoenix";
import { LiveSocket } from "phoenix_live_view";

import "./window_events";
import "./progress";
import Hooks from "./hooks";
import * as Sentry from "@sentry/browser";

const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
const env = process.env.NODE_ENV === "production" ? "prod" : "dev";

if (env == "prod") {
  Sentry.init({
    dsn: "https://4717ea5d87b187fc45e646b97d8316dd@errors.qonvoy.cloud/17",
    release: "26.1.0",
    environment: env,
    replaysSessionSampleRate: env === "dev" ? 1.0 : 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: env === "dev" ? 1.0 : 0.1,
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  });
}

function getParams() {
  try { cookieConsent = JSON.parse(localStorage.getItem("cookie_consent") || '{"consent": "unknown"}'); }
  catch { cookieConsent = {}; }

  return { _csrf_token: csrfToken, cookie_consent: cookieConsent }
}

const liveSocket = new LiveSocket("/live", Socket, {
  hooks: Hooks,
  params: getParams,
  dom: {
    onBeforeElUpdated: (fromEl, toEl) => {
      if (["DIALOG", "DETAILS"].indexOf(fromEl.tagName) >= 0) {
        Array.from(fromEl.attributes).forEach(attr => {
          toEl.setAttribute(attr.name, attr.value);
        });
      }
    }
  }
});

liveSocket.connect();

// expose liveSocket on window for web console debug logs and latency simulation:
// liveSocket.enableDebug()
// liveSocket.enableLatencySim(1000)  // enabled for duration of browser session
// >> liveSocket.disableLatencySim()
window.liveSocket = liveSocket;
